export default "__VITE_ASSET__518bf9c5__"